import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Translation, getI18n } from 'react-i18next';
import { List, Typography, Button } from 'antd';

import QueryString from '../../../../../lib/QueryString';
import { pathTo } from '../../../Routes';
import Logger from '../../../../../lib/Logger';
import ResourceCard from '../containers/ResourceCardContainer';
import ResourcesScreenTabs from './ResourcesScreenTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';
import notification from '../../../elements/lib/NotificationWrapper';

const { Title } = Typography;

const ResourcesList = ({
  careGuideId,
  careGuide,
  partnershipId,
  partnershipName,
  component,
  page,
  limit,
  order,
  tab,
  search,
  serviceTags,
  total,
  load,
  history,
  onChangeTab,
  extraContent,
  width,
  profileId,
  isDownload,
  generatePDF,
  ...props
}) => {
  useEffect(() => {
    const filter = {};

    if (tab) filter[tab] = true;
    if (search !== '') filter.search = search;
    if (serviceTags) filter.service_tags = serviceTags;

    load(careGuideId, page, limit, order, filter);
  }, [careGuideId, page, limit, order, tab, search, serviceTags, load]);

  const pagination = careGuideId
    ? {
        onChange: (newPage, pageSize) => {
          const path = pathTo(component, {
            id: careGuideId,
            page: newPage,
            limit: pageSize,
          });
          history.push(QueryString.append(path));
        },
        current: page,
        pageSize: limit,
        total: total,
        showSizeChanger: false,
      }
    : null;

  const handleAllDownloadPDF = (careGuideId, page, limit, order) => {
    const filter = {};

    if (tab) filter[tab] = true;
    if (search !== '') filter.search = search;
    if (serviceTags) filter.service_tags = serviceTags;

    generatePDF(careGuideId, page, limit, order, filter, (success) => {
      if (success) {
        MixpanelTracker.mixpanelTrack(
          mixpanelEventsEnum.RESOURCE.EXPORT_RESOURCES_PDF,
          {
            partnershipName: careGuide.partnership.name,
            partnershipId: careGuide.partnership.id,
          }
        );
        notification.success(
          getI18n().t('resource_card_action_download_success')
        );
      } else {
        notification.error(
          getI18n().t('resource_card_action_download_failure')
        );
      }
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <ResourcesScreenTabs
            onChangeTab={onChangeTab}
            tab={tab}
            extraContent={
              !(width <= 576) ? extraContent(props.list.length, total) : {}
            }
          />
          {partnershipId && total > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                className='icon-btn'
                type='default'
                size='large'
                disabled={isDownload}
                onClick={() =>
                  handleAllDownloadPDF(careGuideId, page, limit, order)
                }
              >
                <FontAwesomeIcon
                  icon={faFileArrowDown}
                  className={'icon-active'}
                />
                {t('resource_card_action_download_pdf')}
              </Button>
            </div>
          )}
          {width <= 576 && (
            <Title
              level={5}
              style={{
                textAlign: 'center',
                color: '#7B7B7B',
                fontWeight: 'normal',
              }}
            >
              {t('resource_screen_tabs_title_show_resources', {
                showList: props.list.length,
                total: total,
              })}
            </Title>
          )}
          <List
            className='resources-list'
            dataSource={props.list}
            grid={{
              gutter: 18,
              xs: 1,
              sm: 2,
              md: 2,
              lg: 3,
              xl: 3,
              xxl: 3,
            }}
            pagination={page === 1 && total <= limit ? false : pagination}
            renderItem={(item) =>
              item?.id !== undefined && (
                <List.Item>
                  <ResourceCard
                    page={page}
                    limit={limit}
                    order={order}
                    profileId={profileId}
                    careGuideId={careGuideId}
                    careGuide={careGuide}
                    partnershipId={partnershipId}
                    partnershipName={partnershipName}
                    item={item}
                    search={search}
                    serviceTags={serviceTags}
                    isDownload={isDownload}
                  />
                </List.Item>
              )
            }
          />
        </>
      )}
    </Translation>
  );
};

export default withRouter(ResourcesList);

Logger.log('silly', `ResourcesList loaded.`);
